import logo from '../../assets/img/logo.png';
import './Main.style.scss'

const Main = () => {
    return (
        <div className="background">
            <img src={logo} alt="suma" width="300"/>
            <span className="span-main">Coloca el nombre de tu empresa en la url usando
                letras minusculas ejemplo "mapas.sumaenlinea.mx/empresa"</span>
        </div>
    )
}

export default Main
